import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterContentChecked, CSP_NONCE, ChangeDetectorRef, Component, Inject, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

import { environment } from './../../../environments/environment';
import { NonceService } from 'src/app/services/nonce.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterContentChecked {

  isScreenSmall: boolean = false;
  hasBackdrop: boolean = false;
  opened = false;
  disableClose = false;
  mode: any;
  openPanelIndex = -1;
  currentPath: string = "";
  userName: string = "";
  userEmail: string = "";
  userId: any;
  pageTitle: string ="Bienvenido!";
  errorMessage : string =""; //Mensaje de error
  tiempoEsperaRecarga: number = 60000;
  userData: any = [];

  panelExpandidoEstablecimientos: boolean = false;
  panelExpandidoDispositivos: boolean = false;
  panelExpandidoTanques: boolean = false;
  panelExpandidoCervezas: boolean = false;
  panelExpandidoAlarmas: boolean = false;
  panelExpandidoPedidos: boolean = false;
  panelExpandidoRecargas: boolean = false;
  panelExpandidoClientes: boolean = false;
  panelExpandidoUsuarios: boolean = false;
  panelExpandidoEstadisticas: boolean = false;
  panelExpandidoVistas: boolean = false;
  establecimientos: boolean = false;
  panelExpandedMap: { [key: string]: boolean } = {};
  panelSelectionMap: { [key: string]: boolean } = {};

  routesConfig = [
    { path: '/home', requiresProId: false },
    { path: '/home/establecimientos', requiresProId: false },
    { path: '/perfil', requiresProId: false },
    { path: '/establecimientos', requiresProId: false },
    { path: '/establecimientos/agregar', requiresProId: true },
    { path: '/establecimientos/mapa', requiresProId: false },
    { path: '/establecimientos/alarmas', requiresProId: false },
    { path: '/dispositivos', requiresProId: false },
    { path: '/dispositivos/agregar', requiresProId: true },
    { path: '/tanques', requiresProId: false },
    { path: '/tanques/agregar', requiresProId: true },
    { path: '/recargas/historial', requiresProId: false },
    { path: '/pedido/agregar', requiresProId: true },
    { path: '/pedidos', requiresProId: true },
    { path: '/cervezas/agregar', requiresProId: true },
    { path: '/cervezas', requiresProId: false },
    { path: '/alarmas/activas', requiresProId: false },
    { path: '/alarmas/historial', requiresProId: false },
    { path: '/configuracion/alarmas', requiresProId: false },
    { path: '/clientes', requiresProId: true },
    { path: '/clientes/agregar', requiresProId: true },
    { path: '/usuarios', requiresProId: true },
    { path: '/usuarios/agregar', requiresProId: true },
    { path: '/estadisticas', requiresProId: true },
    { path: '/estadisticas/consumo', requiresProId: false },
    { path: '/canalejas', requiresProId: false },
  ];
  mostrar: boolean | undefined;
  cspNonceV: any;

  //FECHAS
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate();
  mes: number = this.fechaActual.getMonth();
  anio: number = this.fechaActual.getFullYear();
  nombresMeses: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  nombreMes: string = this.nombresMeses[this.mes];
  sFechaActual: string = this.dia + " de " + this.nombreMes + " de " + this.anio;

  //RELOJ
  time = new Date();
  intervalReloj: any;

  firstErrorTimestamp: number | null = null; //Primer error 429

  @ViewChild('sidenavContent') sidenavContent: any;

  constructor(private breakpointObserver: BreakpointObserver, private router: Router, private userService: UserService,
    private userDataService: UserDataService, private error429: Error429Service, private changeDetector: ChangeDetectorRef,
    @Inject(CSP_NONCE) private cspNonce: string) {
    this.cspNonceV = cspNonce;
    this.userData = this.userDataService.getUserData();
    this.currentPath = this.router.url;
    this.mostrar = this.checkRouteAuthorization(this.currentPath);
    this.userName = this.userData.user_fullname;
    this.userEmail = this.userData.email;
    this.userId = this.userData.id;
    if (this.currentPath === "/canalejas") {
      if (this.userData.cliente_id === 6 || this.userData.pro_id === 4) {
        this.mostrar = true;
      } else {
        this.mostrar = false;
      }
    }
    if(this.error429.getError() == false){
    } else{
      this.errorMessage = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
      const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
      if(storedTimestamp == null){
        this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
        localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
      } else {
        this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
      }
      this.recargarPaginaDespuesDeTiempo();
    }
    /*this.userSubscription = this.userService.getUser().subscribe({
      next: resp =>{
        this.userData = resp;
        this.mostrar = this.checkRouteAuthorization(this.currentPath);
        this.userName = resp.user_fullname;
        this.userEmail = resp.email;
        this.userId = resp.id;
        if (this.currentPath === "/canalejas") {
          if (this.userData.cliente_id === 6 || this.userData.pro_id === 4) {
            this.mostrar = true;
          } else {
            this.mostrar = false;
          }
        }
      },error:err => {
        console.log(err.error.message);
        console.log(err.statusText);
        if (err.status == 429) {
          this.errorMessage = "Se han recibido demasiadas peticiones, espere un momento por favor, y la página se recargará automáticamente.";
          console.log(this.errorMessage);
          const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
          if(storedTimestamp == null){
            this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
            localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
          } else {
            this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
          }
          console.log(storedTimestamp);
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete:() => {}
    });*/
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalReloj);
  }

  //Función para ver si en la ruta actual se necesita o no ser super usuario para verla
  checkRouteAuthorization(path: string): boolean {
    //Los admin tienen permiso de editar Usuario pero no editar cliente
    if(this.urlValidaEditarUsuario() && this.userData.pro_id == 1){
      return true;
    }
    //Solo super admin
    if(this.urlValidaEditarCliente() || this.urlValidaEditarUsuario()){
      if (this.userData.pro_id == 4){
        return true;
      } else {
        return false;
      }
    }
    //Todos los usuarios pueden ver los datos
    if(this.urlValidaVerDispositivo() || this.urlValidarVerDatosDispositivo()|| this.urlValidaVerEstablecimiento() || this.urlValidaVerCerveza() ||  this.urlValidaVerTanque() || this.urlValidaVerEstablecimientoCompleto()){
      return true;
    }
    //El root y admin son los unicos que pueden añadir y editar 
    if(this.urlValidaEditarCerveza() || this.urlValidaEditarDispositivo() || this.urlValidaEditarTanque() || this.urlValidaEditarEstablecimiento()){
      if (this.userData.pro_id == 4 || this.userData.pro_id == 1){
        return true;
      } else {
        return false;
      }
    }
    const routeConfig = this.routesConfig.find(config => config.path === path);
    if (routeConfig) {
      if (routeConfig.requiresProId) {
        //Excepciones para el admin
        if(path == '/usuarios' || path == '/usuarios/agregar' || path == '/pedidos' || path == '/establecimientos/agregar' ||
        path == '/dispositivos/agregar' || path == '/tanques/agregar' || path == '/pedido/agregar' || path == '/cervezas/agregar'){
          if(this.userData.pro_id == 1){
            return true;
          }
        }
        //Excepciones para el hostelero
        if(path == '/pedidos' || path == '/pedido/agregar'){
          if(this.userData.pro_id == 2){
            return true;
          }
        }
        //El resto solo el super admin
        return this.userData.pro_id == 4;
      }
      //El Home de dispositivos solo lo pueden ver los que son root
      if(path == '/home'){
        if(this.userData.pro_id == 4){
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
    return false; // La ruta no está en routesConfig, no autorizada
  }

  togglePanelExpansion(panelKey: string): void {
    for (const key in this.panelExpandedMap) {
      if (key !== panelKey) {
        this.panelExpandedMap[key] = false; // Colapsar todos los demás paneles
      }
    }
    this.panelExpandedMap[panelKey] = !this.panelExpandedMap[panelKey];
  }

  togglePanelSelection(panelKey: string): void {
    this.panelSelectionMap[panelKey] = !this.panelSelectionMap[panelKey];
  }

  removeGoogleapiScript() {
    const scriptSrc = "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap&loading=async";
    // Buscar el script existente
    const existingScript = document.querySelector(`script[src^="${scriptSrc}"]`);
    if (existingScript) {
      // Eliminar el script si existe
      document.head.removeChild(existingScript);
    }
  }

  ngOnInit(): void {
    //Se utiliza el valor 1169px como la resolución a partir de la cual se mostrará el componente sidenav
    //y nos ayudará a hacer la aplicación responsie.
    this.intervalReloj = setInterval(() => {
      this.time = new Date();
    }, 1000);
    const customBreakpoint = this.breakpointObserver.observe([`(max-width: 1169px)`]);
    customBreakpoint.subscribe(result => {
      this.isScreenSmall = result.matches;
      //Ver el sidenav debería estar abierto o cerrado cuando se carga la página.
      this.opened=!this.isScreenSmall;
      if (this.isScreenSmall){
        //Ver si el hasbackdrop debería utilizarse cuando se abre el sidenav.
        this.hasBackdrop = true;
        //Ver si con qué modo se debe abrir el mat-sidenav.
        this.mode = 'over';
        this.disableClose = false;
      }else{
        this.hasBackdrop = false;
        this.mode = 'side';
        //Cuando la pantalla es grande el sidenav no debe abrirse
        this.disableClose = true;
      }
    });

    //Conseguimos los datos del usuario y corroboramos que está identificado
    /*this.userService.getUser().subscribe({
      next: resp =>{
        this.userData = resp;
        this.userName = resp.user_fullname;
        this.userEmail = resp.email;
        this.userId = resp.id;
      },error:err => {
        if (err.status == 429) {
          this.errorMessage = "Se han recibido demasiadas peticiones, espere un momento por favor, y la página se recargará automáticamente.";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = "";
        }
      },complete:() => {
        this.mostrar = this.checkRouteAuthorization(this.currentPath);
      }
    });*/

    /* Cuando se carga el componente home hay que ver que ruta se está cargando 
    para cambiar el título de la página y para mantener el color y el sidenav abierto o no*/
    if (this.currentPath == "/perfil"){
      this.pageTitle = "Perfil de Usuario"; 
    }
    if (this.currentPath == "/home"){
      this.pageTitle = "Bienvenido!"; 
      this.panelSelectionMap["homeD"] = true;
    }
    if (this.currentPath == "/home/establecimientos"){
      this.pageTitle = "Bienvenido!"; 
      this.panelSelectionMap["homeE"] = true;
    }
    if (this.currentPath == "/establecimientos"){
      this.pageTitle = "Lista de Establecimientos"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelSelectionMap["establecimientosAdmin"] = true;
      this.panelExpandidoEstablecimientos=true;
    }
    if (this.currentPath == "/establecimientos/mapa"){
      this.pageTitle = "Mapa de Establecimientos"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelSelectionMap["establecimientosMapa"] = true;
      this.panelExpandidoEstablecimientos=true;
    }
    if (this.currentPath == "/establecimientos/agregar"){
      this.pageTitle = "Nuevo Establecimiento"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelSelectionMap["establecimientosNuevo"] = true;
      this.panelExpandidoEstablecimientos=true;
    }
    if(this.urlValidaVerEstablecimiento()){
      this.pageTitle = "Ver Establecimiento"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelExpandidoEstablecimientos=true;
    }
    if(this.urlValidaVerEstablecimientoCompleto()){
      this.pageTitle = "Monitorizar Establecimiento"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelExpandidoEstablecimientos=true;
    }
    if(this.urlValidaEditarEstablecimiento()){
      this.pageTitle = "Editar Establecimiento"; 
      this.panelSelectionMap["establecimientos"] = false;
      this.panelExpandidoEstablecimientos=true;
    }
    if (this.currentPath == "/dispositivos"){
      this.pageTitle = "Lista de Dispositivos"; 
      this.panelSelectionMap["dispositivos"] = false;
      this.panelSelectionMap["dispositivosAdmin"] = true;
      this.panelExpandidoDispositivos=true;
    }
    if (this.currentPath == "/dispositivos/agregar"){
      this.pageTitle = "Nuevo Dispositivo"; 
      this.panelSelectionMap["dispositivos"] = false;
      this.panelSelectionMap["dispositivosNuevo"] = true;
      this.panelExpandidoDispositivos=true;
    }
    if (this.urlValidaEditarDispositivo()){
      this.pageTitle = "Editar Dispositivo"; 
      this.panelSelectionMap["dispositivos"] = false;
      this.panelExpandidoDispositivos=true;
    }
    if (this.urlValidaVerDispositivo()){
      this.pageTitle = "Monitorizar Dispositivo"; 
      this.panelSelectionMap["dispositivos"] = false;
      this.panelExpandidoDispositivos=true;
    }
    if (this.urlValidarVerDatosDispositivo()){
      this.pageTitle = "Ver Dispositivo"; 
      this.panelSelectionMap["dispositivos"] = false;
      this.panelExpandidoDispositivos=true;
    }
    if (this.currentPath == "/tanques"){
      this.pageTitle = "Lista de Tanques"; 
      this.panelSelectionMap["tanques"] = false;
      this.panelSelectionMap["tanquesAdmin"] = true;
      this.panelExpandidoTanques=true;
    }
    if (this.currentPath == "/tanques/agregar"){
      this.pageTitle = "Nuevo Tanque"; 
      this.panelSelectionMap["tanques"] = false;
      this.panelSelectionMap["tanquesNuevo"] = true;
      this.panelExpandidoTanques=true;
    }
    if (this.urlValidaEditarTanque()){
      this.pageTitle = "Editar Tanque"; 
      this.panelSelectionMap["tanques"] = false;
      this.panelExpandidoTanques=true;
    }
    if (this.urlValidaVerTanque()){
      this.pageTitle = "Ver Tanque"; 
      this.panelSelectionMap["tanques"] = false;
      this.panelExpandidoTanques=true;
    }
    if (this.currentPath == "/pedido/agregar"){
      this.pageTitle = "Solicitar de Pedido"; 
      this.panelSelectionMap["pedidos"] = false;
      this.panelSelectionMap["nuevoPedido"] = true;
      this.panelExpandidoPedidos=true;
    }
    if (this.currentPath == "/pedidos"){
      this.pageTitle = "Pedidos"; 
      this.panelSelectionMap["pedidos"] = false;
      this.panelSelectionMap["listaPedidos"] = true;
      this.panelExpandidoPedidos=true;
    }
    if (this.currentPath == "/recargas/historial"){
      this.pageTitle = "Historial de Recargas"; 
      this.panelSelectionMap["recargas"] = false;
      //this.panelSelectionMap["tanquesRecargas"] = true;
      this.panelExpandidoRecargas=true;
    }
    if (this.currentPath == "/cervezas/agregar"){
      this.pageTitle = "Agregar Cerveza"; 
      this.panelSelectionMap["cervezas"] = false;
      this.panelSelectionMap["cervezasNuevo"] = true;
      this.panelExpandidoCervezas=true;
    }
    if (this.currentPath == "/cervezas"){
      this.pageTitle = "Lista de Cervezas"; 
      this.panelSelectionMap["cervezas"] = false;
      this.panelSelectionMap["cervezasAdmin"] = true;
      this.panelExpandidoCervezas=true;
    }
    if (this.urlValidaEditarCerveza()){
      this.pageTitle = "Editar Cerveza"; 
      this.panelSelectionMap["cervezas"] = false;
      this.panelExpandidoCervezas=true;
    }
    if (this.urlValidaVerCerveza()){
      this.pageTitle = "Ver Cerveza"; 
      this.panelSelectionMap["cervezas"] = false;
      this.panelExpandidoCervezas=true;
    }
    if (this.currentPath == "/alarmas/activas"){
      this.pageTitle = "Alarmas Activas"; 
      this.panelSelectionMap["alarmas"] = false;
      this.panelSelectionMap["alarmasActivas"] = true;
      this.panelExpandidoAlarmas=true;
    }
    if (this.currentPath == "/alarmas/historial"){
      this.pageTitle = "Historial de Alarmas"; 
      this.panelSelectionMap["alarmas"] = false;
      this.panelSelectionMap["alarmasHistorial"] = true;
      this.panelExpandidoAlarmas=true;
    }
    if (this.currentPath == "/configuracion/alarmas"){
      this.pageTitle = "Configuración de Alarmas"; 
      this.panelSelectionMap["alarmas"] = false;
      this.panelSelectionMap["alarmasConfiguracion"] = true;
      this.panelExpandidoAlarmas=true;
    }
    if (this.currentPath == "/establecimientos/alarmas"){
      this.pageTitle = "Establecer Alarmas"; 
      this.panelSelectionMap["alarmas"] = false;
      this.panelSelectionMap["establecimientosAlarmas"] = true;
      this.panelExpandidoAlarmas=true;
    }
    if (this.currentPath == "/clientes/agregar"){
      this.pageTitle = "Nuevo Cliente"; 
      this.panelSelectionMap["clientes"] = false;
      this.panelSelectionMap["clientesNuevo"] = true;
      this.panelExpandidoClientes=true;
    }
    if (this.currentPath == "/clientes"){
      this.pageTitle = "Lista de Clientes"; 
      this.panelSelectionMap["clientes"] = false;
      this.panelSelectionMap["clientesLista"] = true;
      this.panelExpandidoClientes=true;
    }
    if (this.urlValidaEditarCliente()){
      this.pageTitle = "Editar Cliente"; 
      this.panelSelectionMap["clientes"] = false;
      this.panelExpandidoClientes=true;
    }
    if (this.currentPath == "/usuarios/agregar"){
      this.pageTitle = "Nuevo Usuario"; 
      this.panelSelectionMap["usuarios"] = false;
      this.panelSelectionMap["usuariosNuevo"] = true;
      this.panelExpandidoUsuarios=true;
    }
    if (this.currentPath == "/usuarios"){
      this.pageTitle = "Lista de Usuarios"; 
      this.panelSelectionMap["usuarios"] = false;
      this.panelSelectionMap["usuariosLista"] = true;
      this.panelExpandidoUsuarios=true;
    }
    if (this.urlValidaEditarUsuario()){
      this.pageTitle = "Editar Usuario"; 
      this.panelSelectionMap["usuarios"] = false;
      this.panelExpandidoUsuarios=true;
    }
    if (this.currentPath == "/estadisticas"){
      this.pageTitle = "Estadísticas de Uso"; 
      this.panelSelectionMap["estadisticas"] = false;
      this.panelSelectionMap["estadisticasGlobales"] = true;
      this.panelExpandidoEstadisticas=true;
    }
    if (this.currentPath == "/estadisticas/consumo"){
      this.pageTitle = "Estadísticas de Consumo"; 
      this.panelSelectionMap["estadisticas"] = false;
      this.panelSelectionMap["estadisticasConsumo"] = true;
      this.panelExpandidoEstadisticas=true;
    }
    if (this.currentPath == "/canalejas"){
      this.pageTitle = "Mercado Canalejas Madrid"; 
      this.panelSelectionMap["vistas"] = false;
      this.panelSelectionMap["vistasCanalejas"] = true;
      this.panelExpandidoVistas=true;
    }
  }

  recargarPaginaDespuesDeTiempo() {
    if (this.firstErrorTimestamp !== null) {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - this.firstErrorTimestamp;
      const remainingTime = Math.max(this.tiempoEsperaRecarga - elapsedTime, 0);
      console.log(remainingTime);
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, remainingTime);
    } else {
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, this.tiempoEsperaRecarga);
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
      this.error429.setError(false);
    });
    localStorage.removeItem('firstErrorTimestamp');
  }

  togglePanel(index: number) {
    if (this.openPanelIndex === index) {
      this.openPanelIndex = -1;  // Cierra el panel si se hace clic en el mismo
    } else {
      this.openPanelIndex = index;  // Abre el panel correspondiente
    }
  }

  //Función para validar las rutas para ver detalles de un dispositivo
  urlValidaVerEstablecimiento() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 3 && pathParts[1] === 'establecimiento' && !isNaN(Number(pathParts[2]));
  }

  urlValidaVerEstablecimientoCompleto() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1] === 'establecimiento' && pathParts[2] === 'ver' && !isNaN(Number(pathParts[3]));
  }

  urlValidaEditarEstablecimiento() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && !isNaN(Number(pathParts[1])) && pathParts[2] === 'editar' && pathParts[3] === 'establecimiento';
  }

  urlValidaVerDispositivo() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 3 && pathParts[1] === 'dispositivo' && !isNaN(Number(pathParts[2]));
  }

  urlValidarVerDatosDispositivo(){
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1] === 'dispositivo' && pathParts[2] === 'ver' && !isNaN(Number(pathParts[3]));
  }

  urlValidaEditarDispositivo() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && !isNaN(Number(pathParts[1])) && pathParts[2] === 'editar' && pathParts[3] === 'dispositivo';
  }

  urlValidaEditarUsuario() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1]=== 'usuarios' && !isNaN(Number(pathParts[2])) && pathParts[3] === 'editar';
  }

  urlValidaEditarCliente() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1]=== 'clientes' && !isNaN(Number(pathParts[2])) && pathParts[3] === 'editar';
  }

  //Tanques
  urlValidaEditarTanque() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1]=== 'tanques' && !isNaN(Number(pathParts[2])) && pathParts[3] === 'editar';
  }

  urlValidaVerTanque() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 3 && pathParts[1] === 'tanque' && !isNaN(Number(pathParts[2]));
  }

  //Cervezas
  urlValidaEditarCerveza() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 4 && pathParts[1]=== 'cervezas' && !isNaN(Number(pathParts[2])) && pathParts[3] === 'editar';
  }
  urlValidaVerCerveza() {
    let pathParts = this.currentPath.split('/');
    return pathParts.length === 3 && pathParts[1] === 'cerveza' && !isNaN(Number(pathParts[2]));
  }

  logout(){
    this.userService.logOut();
    //Eliminamos el token de sesion
    //this.userService.deleteSessionToken();
    this.userService.removeLocalSessionToken();
    //Eliminados los datos de usuario del local storage
    this.userDataService.clearUserData();
    //Eliminamos el error del local storage
    this.error429.clearError();
    //Eliminar el script de google maps
    this.removeGoogleapiScript();
    /* La cookie que guarda el token de sesion de elimina pero es necesario redirigir al /login
    ya que sino hay que esperar a que el usuario intente cargar otra vista para que el authorize-guard
    devuelva true y redirija al /login */
    this.router.navigateByUrl("/login");
  }

}
